import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {IMasterData} from '../interfaces/IMasterData';
import {GeneralService} from '../../../services/general.service';
import {Injectable} from '@angular/core';
import {AuthService} from '../../../auth/auth.service';
import {Page} from '../../../model/page';
import * as _ from 'lodash';
import {EDIServices} from '../../../services/edi.services';
import {saveAs} from '@progress/kendo-file-saver';

@Injectable()
export class MasterDataService extends GeneralService implements EDIServices<Observable<IMasterData>, IMasterData, number> {

    constructor(
        protected http: HttpClient,
        protected authService: AuthService
    ) {
        super(http);
    }

    getById(id): Observable<any> {
        if (_.isEmpty(id)) {
            return Observable.of(this.initialize());
        }

        const url = `${this.apiUrl}/master-data/view`;
        return this.http.get(url, {params: {MD1_ID: id}});
    }

    private getParams(data: IMasterData) {
        return {
            MD1_ID: data.MD1_ID
        };
    }

    preload(): Observable<any> {
        const url = `${this.apiUrl}/master-data/preload`;
        return this.http.get(url);
    }

    save(masterData: IMasterData, isCreate: boolean): Observable<any> {
        return isCreate ? this.create(masterData) : this.update(masterData);
    }

    delete(masterData: IMasterData): Observable<any> {
        const url = `${this.apiUrl}/master-data/delete`;
        return this.http.post(url, masterData);
    }

    export(preferences, page: Page): Observable<any> {
        const url = '/master-data/export';
        let params = new HttpParams();
        params = this.applyFilters(page, params);
        params = params.append('CU1_ID', preferences.CU1_ID);
        params = params.append('CO1_ID', preferences.CO1_ID);
        params = params.append('col', preferences.columns);

        return this.http.get(this.apiUrl + url, {params: params});
    }

    exportImmediate(preferences, page: Page): Observable<any> {
        const url = '/master-data/export';
        let params = new HttpParams();
        params = this.applyFilters(page, params);
        params = params.append('immediate', '1');
        params = params.append('type', 'xls');
        params = params.append('subtype', '');
        params = params.append('CU1_ID', preferences.CU1_ID);
        params = params.append('CO1_ID', preferences.CO1_ID);
        params = params.append('col', preferences.columns);
        params = params.append('perPage', page.size.toString());
        params = params.append('page', page.pageNumber.toString());

        return this.http.get(this.apiUrl + url, {params, responseType: 'blob', observe: 'response'});
    }

    importFromFile(fileToUpload: File, CU1_ID, CO1_ID): Observable<any> {
        const formData = new FormData();
        formData.append('fileKey', fileToUpload, fileToUpload.name);
        formData.append('fileName', fileToUpload.name);
        formData.append('CU1_ID', CU1_ID);
        formData.append('CO1_ID', CO1_ID);
        const url = `${this.apiUrl}/master-data/file-import`;
        return this.http.post(url, formData);
    }

    generateXls(xlsData: HttpResponse<Blob>, fileName: string) {
        super.generateXls(xlsData, fileName);
    }

    private create(masterData: IMasterData): Observable<any> {
        const url = `${this.apiUrl}/master-data/create`;
        return this.http.post(url, masterData);
    }

    private update(masterData: IMasterData): Observable<any> {
        const url = `${this.apiUrl}/master-data/update`;
        return this.http.post(url, masterData);
    }

    public importPreload(): Observable<any> {
        const url = `${this.apiUrl}/master-data/import-preload`;
        return this.http.get(url);
    }

    public getDataList(page: Page): Observable<any> {
        const url = '/master-data';
        return this.getRestList(page, url);
    }

    public initialize() {
        return {
            MD1_ID: null,
            CU1_ID: null,
            CO1_ID: null,
            RA1_ID: null,
            CONTRACT_BIN_ID: null,
            ITEM_ID: null,
            CUSTOMER_PART_NO: null,
            MD1_BARCODE: null,
            MD1_ITEM_DESC: null,
            MD1_EXTENDED_DESC: null,
            MD1_FAMILY: null,
            MD1_CONTRACT_NO: null,
            MD1_REORDER_QTY: null,
            MD1_MIN_QTY: null,
            MD1_MAX_QTY: null,
            MD1_CAPACITY: null,
            MD1_ON_HAND_QTY: null,
            MD1_AVAILABLE_QTY: null,
            MD1_PRICE: null,
            MD1_UM: null,
            MD1_UM_SIZE: null,
            MD1_FLAG: null,
            MD1_LINE: null,
            MD1_LINE_FEED: null,
            MD1_LINE_STATION: null,
            MD1_BIN_TYPE: null,
            MD1_BIN_SIZE: null,
            MD1_REP: null,
            MD1_REGION: null,
            MD1_OWNER_OF_BIN: null,
            MD1_OWNER_OF_RACK: null,
            MD1_CREATED_ON: null,
            MD1_CREATED_BY: null,
            MD1_MODIFIED_ON: null,
            MD1_MODIFIED_BY: null,
            MD1_DELETE_FLAG: null
        };
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/oes/services/master-data.service.ts